import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
	name: 'user',
	initialState: {
		user: null,
		accessToken: null,
		refreshToken: null,
		isAuthenticated: false,
		persist: true,
		loading: false,
		loadingRefreshToken: false,
		loadingSyncUserData: false,
		loadingLogin: false,
	},
	reducers: {
		loginStart: (state) => {
			state.loadingLogin = true;
		},
		loginSuccess: (state, { payload }) => {
			state.loadingLogin = false;
			state.isAuthenticated = true;
			state.user = payload.user;
			state.accessToken = payload.accessToken ?? state.accessToken;
			state.refreshToken = payload.refreshToken ?? state.refreshToken;
		},
		loginFailure: (state) => {
			state.loadingLogin = false;
			state.isAuthenticated = false;
			state.user = null;
			state.accessToken = null;
			state.refreshToken = null;
		},
		refreshTokenStart: (state) => {
			state.loadingRefreshToken = true;
		},
		refreshTokenSuccess: (state, { payload }) => {
			state.loadingRefreshToken = false;
			state.isAuthenticated = true;
			state.user = payload.user;
			if (payload.accessToken) state.accessToken = payload.accessToken;
			if (payload.refreshToken) state.refreshToken = payload.refreshToken;
		},
		refreshTokenFailure: (state) => {
			state.loadingRefreshToken = false;
		},
		logout: (state) => {
			state.loadingLogin = false;
			state.loadingRefreshToken = false;
			state.isAuthenticated = false;
			state.user = null;
			state.accessToken = null;
			state.refreshToken = null;
		},
		getSyncUserDataStart: (state) => {
			state.loadingSyncUserData = true;
		},
		getSyncUserDataSuccess: (state, { payload: { user } }) => {
			state.loadingSyncUserData = false;
			state.user = user;
		},
		getSyncUserDataFailure: (state) => {
			state.loadingSyncUserData = false;
		},
	},
});

export const {
	loginStart,
	loginSuccess,
	loginFailure,
	refreshTokenStart,
	refreshTokenSuccess,
	refreshTokenFailure,
	logout,
	getSyncUserDataStart,
	getSyncUserDataSuccess,
	getSyncUserDataFailure,
} = userSlice.actions;
export default userSlice.reducer;